import Rails from '@rails/ujs'

$(document).ready(() => {
  $(
    [
      '#congresses_users_register_professional_group',
      '#congresses_users_insert_professional_group',
      '#user_professional_group_id',
      '#user_professional_group'
    ].join(', ')
  ).on(
    'change',
    change => {
      const groups = $(change.target)
        .find('option')
        .toArray()
        .reduce((acc, el) => ({ ...acc, [$(el).html()]: $(el).val() }), {})

      const doctor = groups['Lekarz'],
            pharmacist = groups['Farmaceuta'],
            nurse = groups['Pielęgniarka / Położna'],
            student = groups['Student'],
            representant = groups['Reprezentant'],
            veterinary = groups['Lekarz weterynarii'],
            station_employee = groups['Pracownik stacji epidemiologicznej'],
            optician = groups['Optyk'],
            orthoptist = groups['Ortoptysta'],
            optometrist = groups['Optometrysta']
  
      const professional_group = $(change.target).children('option:selected').val()
  
      if (professional_group == doctor) {
        $('.block_specializations').show()
      } else {
        $('.block_specializations').hide()
      }
  
      if ( [doctor, nurse, pharmacist, veterinary, optician, orthoptist, optometrist].includes(professional_group) ){
        const npwzLabel = [optician, orthoptist, optometrist].includes(professional_group) ? 'RIZM' : 'NPWZ'
        $('.block_npwz label').text(npwzLabel)
        $('.block_npwz .npwz_label_text').text(npwzLabel)
        $('.block_npwz input').attr('placeholder', npwzLabel)
        $('.block_npwz .hint').text(`Podaj poprawny ${npwzLabel}`)
        $('.block_npwz').show()
      } else {
        $('.block_npwz').hide()
      }
  
      if (professional_group == student) {
        $('.block_student').show()
      } else {
        $('.block_student').hide()
      }
  
      if ([representant].includes(professional_group)) {
        $('.block_company, .block_representant').show()
      } else {
        $('.block_company, .block_representant').hide()
      }

      if (professional_group == station_employee) {
        $('.block_station_employee').show()
      } else {
        $('.block_station_employee').hide()
      }
    }
  );

  $('#congresses_users_register_province, #congresses_users_insert_province, #user_province').change(function(e) {
    var province_id = $(this).children('option:selected').val()
    const select_box = $(this).parents('form').find('select[name*="epidemiological_station"]')
    Rails.ajax({
      url: `/api/epidemiological_stations/${province_id}`,
      type: 'get',
      success: data => { $(select_box).html(data) }
    })
  });
});
